var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"secondary-button",attrs:{"data-is-active":_vm.isActive,"disabled":_vm.disabled,"data-variant":_vm.variant},on:{"click":_vm.onClick}},[_vm._t("icon"),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }